export const host = process.env.REACT_APP_API_HOST